<template>
  <div>

    <b-form inline @submit="add()">
        <b-form-select
          placeholder="Статус"
          v-model="newItem.status"
          :options="statusList"
          v-b-tooltip.hover :title="help.status"
          required
          class="mb-2"
          style="width:20%;"
        ></b-form-select>

        <b-form-select
          placeholder="Кому"
          v-model="newItem.user"
          :options="$store.getters.getUsersForList"
          required
          class="mb-2"
          style="width:20%;"
        ></b-form-select>

        <b-form-input placeholder="Наименование начисления" v-model="newItem.reference"  class="mb-2" style="width:40%;"></b-form-input>
        <b-form-input placeholder="Сумма" v-model="newItem.amount" type="number" class="mb-2" style="width:15%;"></b-form-input>
        <b-form-select
          v-model="newItem.typeOfPayment"
          :options="typeOfPaymentList"
          required
          class="mb-2"
        ></b-form-select>
        <b-form-datepicker
          placeholder="Дата"
          v-model="newItem.dataSort"
          type="data"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          locale="ru"
          required
          class="mb-2"
        ></b-form-datepicker>
        <b-form-input placeholder="id Задачи" v-model="newItem.task" type="number" readonly class="mb-2" style="width:100px;"> </b-form-input>
        <b-form-input placeholder="id Сделки" v-model="newItem.deal" type="number" readonly class="mb-2" style="width:100px;"></b-form-input>
        <b-form-input placeholder="id Компании" v-model="newItem.company" type="number" readonly class="mb-2" style="width:100px;"></b-form-input>
        <b-form-input placeholder="id Контакта" v-model="newItem.contact" type="number" readonly class="mb-2" style="width:100px;"></b-form-input>
        <b-button v-show="!modeEdit" variant="success" @click="addOperation()" class="mb-2">Добавить</b-button>
        <b-button v-show="modeEdit" variant="primary" @click="updateOperation()" class="mb-2">Изменить</b-button>
        <b-button v-show="modeEdit" variant="danger" v-b-modal="modalConfirmDelete" class="mb-2">Удалить</b-button>
        <!-- <p>operationDefault: {{operationDefault}}</p> -->
        <!-- <p>newItem: {{newItem}}</p> -->

    </b-form>

    <b-modal
      :id="modalConfirmDelete"
      title="Подтвердите удаление операции"
      @ok="deleteOperation()"
      >
      <p class="my-4">При надажтии Ок операция будет удалена!</p>
    </b-modal>

  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    operationDefault: {
      type: Object,
      default: function () {
              return {
                        user: null,
                        contact: null,
                        task: null,
                        deal: null,
                        company: null
                      }
      }
    },
    mode: String, //add или edit
  },
  data() {
    return {
      newItem: {
        dataSort: this.operationDefault.dataSort || new Date(),
        contact: this.operationDefault.contact || null,
        amount: this.operationDefault.amount || 0,
        reference: this.operationDefault.reference || '',
        typeOfPayment: this.operationDefault.typeOfPayment || null,
        status: this.operationDefault.status || 'draft',
        company: this.operationDefault.company || null,
        deal: this.operationDefault.deal || null,
        task: this.operationDefault.task || null,
        user: this.operationDefault.user || null,
        payer: this.operationDefault.payer || '', // Плательщик. Здесь не нужен
        accountId: this.operationDefault.accountId || null,
        id: this.operationDefault.id || null //id cчета. Здесь не нужен
      },
      help: {
        status: 'Черновик - нигде не учитывается;\n \
                Запланировано - есть договорённость с Исполнителем, учитывается в сметах, попадает в зп файл;\n \
                Начиcлено - работы приняты, можно рассчитыватсья;\n \
                Выплачено - расчет произведен;\n \
                Оформлено - все оформлено.'
      }
    }

  },
  computed: {
    ...mapState(['statusList', 'typeOfPaymentList']),
    modeEdit(){
      return this.mode == 'edit'
    },
    modalConfirmDelete() {
      return 'modal' + this.mode //Нужно чтобы отличать модальные окна разных компонентов
    },
  },
  methods: {
    async addOperation() {
      // console.log ( 'Нажата кнопка Добавить' )
      let payload = {
        ENTITY: 'accrual',
        DATE_ACTIVE_FROM: this.newItem.dataSort,
        NAME: this.newItem.reference,
        PROPERTY_VALUES: this.newItem,
      }
      // console.log('Добавляем данные' + this.newItem);
      if  ( await this.$store.dispatch ('entityItemAdd', payload, { root: true } ) != 400 ) {
        console.log('Добавление записи произошло успешно');
        // Обнуляем форму
        this.newItem.amount = 0,
        this.newItem.reference =  '',
        this.newItem.typeOfPayment = null,
        this.newItem.payer = '', // Плательщик. Здесь не нужен
        this.$emit('update-operations-table')
      } else {
        console.log('Ошибка добавления записи');
      }
      // TODO Очищаем форму


    },
    async deleteOperation() {
      let payload = {
        ENTITY: 'accrual',
        ID: this.newItem.id,
      }
      if  ( await this.$store.dispatch ('entityItemDelete', payload, { root: true } ) != 400 ) {
        console.log('Удаление записи произошло успешно');
        this.$emit('update-operations-table')
      } else {
        console.log('Ошибка удаления записи');
      }
    },
    async updateOperation() {
      console.log('Нажата кнопка обновления');
      let payload = {
        ENTITY: 'accrual',
        ID: this.newItem.id,
        DATE_ACTIVE_FROM: this.newItem.dataSort,
        NAME: this.newItem.reference,
        PROPERTY_VALUES: this.newItem,
      }
      if  ( await this.$store.dispatch ('entityItemUpdate', payload, { root: true } ) == 200 ) {
        console.log('Обновление записи произошло успешно');
        this.$emit('update-operations-table')
      } else {
        console.log('Ошибка обновления записи');
      }
    }
  },

}
</script>